// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'cf3a382df9c4004ecb6d63797d10427cdf9a6d00';
export const BUILD_NUMBER = '195';
export const BUILD_TIMESTAMP = '2026-07-15T07:10:50.060Z';
